import React from "react";

export default function TechSupport() {
  return (
    <svg
      width="480"
      height="480"
      viewBox="0 0 480 480"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="TechSupport">
        <g id="Group">
          <g id="Group_2">
            <path
              id="Vector"
              d="M407.648 40H72C54.327 40 40 54.327 40 72V288C40 305.673 54.327 320 72 320H407.648C425.321 320 439.648 305.673 439.648 288V72C439.648 54.327 425.321 40 407.648 40ZM423.648 288C423.648 296.837 416.485 304 407.648 304H72C63.163 304 56 296.837 56 288V72C56 63.163 63.163 56 72 56H407.648C416.485 56 423.648 63.163 423.648 72V288Z"
              fill="#242424"
            />
          </g>
        </g>
        <g id="Group_3">
          <g id="Group_4">
            <path
              id="Vector_2"
              d="M416 0H64C28.67 0.04 0.04 28.67 0 64V320C0.04 355.33 28.67 383.96 64 384H181.392L169.96 424H116C100.536 424 88 436.536 88 452C88 467.464 100.536 480 116 480H364C379.464 480 392 467.464 392 452C392 436.536 379.464 424 364 424H310.04L298.608 384H416C451.33 383.96 479.96 355.33 480 320V64C479.96 28.67 451.33 0.04 416 0ZM364 440C370.627 440 376 445.373 376 452C376 458.627 370.627 464 364 464H116C109.373 464 104 458.627 104 452C104 445.373 109.373 440 116 440H364ZM186.608 424L198.04 384H281.96L293.392 424H186.608ZM464 320C463.974 346.499 442.499 367.974 416 368H64C37.501 367.974 16.026 346.499 16 320V64C16.026 37.501 37.501 16.026 64 16H416C442.499 16.026 463.974 37.501 464 64V320Z"
              fill="#242424"
            />
          </g>
        </g>
        <g id="Group_5">
          <g id="Group_6">
            <path id="Vector_3" d="M248 336H232V352H248V336Z" fill="#242424" />
          </g>
        </g>
        <g id="Group_7">
          <g id="Group_8">
            <path
              id="Vector_4"
              d="M328 152H316.272C314.868 147.53 313.067 143.196 310.888 139.048L319.2 130.744C322.323 127.62 322.323 122.556 319.2 119.432L296.568 96.8C293.444 93.677 288.38 93.677 285.256 96.8L276.952 105.104C272.804 102.928 268.469 101.129 264 99.728V88C264 83.582 260.418 80 256 80H224C219.582 80 216 83.582 216 88V99.728C211.53 101.132 207.196 102.933 203.048 105.112L194.744 96.8C191.62 93.677 186.556 93.677 183.432 96.8L160.8 119.432C157.677 122.556 157.677 127.62 160.8 130.744L169.104 139.048C166.928 143.196 165.129 147.531 163.728 152H152C147.582 152 144 155.582 144 160V192C144 196.418 147.582 200 152 200H163.728C165.132 204.47 166.933 208.804 169.112 212.952L160.8 221.256C157.677 224.38 157.677 229.444 160.8 232.568L183.432 255.2C186.556 258.323 191.62 258.323 194.744 255.2L203.048 246.896C207.196 249.072 211.531 250.871 216 252.272V264C216 268.418 219.582 272 224 272H256C260.418 272 264 268.418 264 264V252.272C268.47 250.868 272.804 249.067 276.952 246.888L285.256 255.2C288.38 258.323 293.444 258.323 296.568 255.2L319.2 232.568C322.323 229.444 322.323 224.38 319.2 221.256L310.896 212.952C313.072 208.804 314.871 204.469 316.272 200H328C332.418 200 336 196.418 336 192V160C336 155.582 332.418 152 328 152ZM320 184H310.16C306.426 184 303.189 186.583 302.36 190.224C300.758 197.238 297.98 203.93 294.144 210.016C292.151 213.175 292.609 217.292 295.248 219.936L302.224 226.912L290.912 238.224L283.936 231.248C281.292 228.609 277.175 228.151 274.016 230.144C267.933 233.995 261.24 236.786 254.224 238.4C250.598 239.226 248.019 242.441 248 246.16V256H232V246.16C232 242.426 229.417 239.189 225.776 238.36C218.762 236.758 212.07 233.98 205.984 230.144C202.825 228.151 198.708 228.609 196.064 231.248L189.088 238.224L177.776 226.912L184.752 219.936C187.391 217.292 187.849 213.175 185.856 210.016C182.02 203.93 179.242 197.238 177.64 190.224C176.811 186.583 173.574 184 169.84 184H160V168H169.84C173.574 168 176.811 165.417 177.64 161.776C179.242 154.762 182.02 148.07 185.856 141.984C187.849 138.825 187.391 134.708 184.752 132.064L177.776 125.088L189.088 113.776L196.064 120.752C198.707 123.391 202.825 123.849 205.984 121.856C212.067 118.005 218.76 115.214 225.776 113.6C229.402 112.774 231.981 109.559 232 105.84V96H248V105.84C248 109.574 250.583 112.811 254.224 113.64C261.238 115.242 267.93 118.02 274.016 121.856C277.175 123.849 281.292 123.391 283.936 120.752L290.912 113.776L302.224 125.088L295.248 132.064C292.609 134.708 292.151 138.825 294.144 141.984C297.994 148.067 300.786 154.76 302.4 161.776C303.226 165.402 306.441 167.981 310.16 168H320V184Z"
              fill="#242424"
            />
          </g>
        </g>
        <g id="Group_9">
          <g id="Group_10">
            <path
              id="Vector_5"
              d="M240 136C217.909 136 200 153.909 200 176C200 198.091 217.909 216 240 216C262.091 216 280 198.091 280 176C279.974 153.92 262.08 136.026 240 136ZM240 200C226.745 200 216 189.255 216 176C216 162.745 226.745 152 240 152C253.255 152 264 162.745 264 176C264 189.255 253.255 200 240 200Z"
              fill="#242424"
            />
          </g>
        </g>
        <g id="Group_11">
          <g id="Group_12">
            <path id="Vector_6" d="M376 232H336V248H376V232Z" fill="#242424" />
          </g>
        </g>
        <g id="Group_13">
          <g id="Group_14">
            <path id="Vector_7" d="M400 264H336V280H400V264Z" fill="#242424" />
          </g>
        </g>
        <g id="Group_15">
          <g id="Group_16">
            <path id="Vector_8" d="M120 232H80V248H120V232Z" fill="#242424" />
          </g>
        </g>
        <g id="Group_17">
          <g id="Group_18">
            <path id="Vector_9" d="M144 264H80V280H144V264Z" fill="#242424" />
          </g>
        </g>
        <g id="Group_19">
          <g id="Group_20">
            <path id="Vector_10" d="M96 80H80V96H96V80Z" fill="#242424" />
          </g>
        </g>
        <g id="Group_21">
          <g id="Group_22">
            <path id="Vector_11" d="M128 80H112V96H128V80Z" fill="#242424" />
          </g>
        </g>
        <g id="Group_23">
          <g id="Group_24">
            <path id="Vector_12" d="M368 80H352V96H368V80Z" fill="#242424" />
          </g>
        </g>
        <g id="Group_25">
          <g id="Group_26">
            <path id="Vector_13" d="M400 80H384V96H400V80Z" fill="#242424" />
          </g>
        </g>
      </g>
    </svg>
  );
}
